import PriceFractionDisplay from "@CheckOrder/features/paymentSummary/components/PriceFractionDisplay";
import useGetPassengerClassPrices
    from "@CheckOrder/features/paymentSummary/features/passengerClassesSummary/hooks/useGetPassengerClassPrices";
import useGetPassengersName
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/hooks/useGetPassengersName";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface PassengerClassSummaryProps {
    passengerIdsGroups: number[][],
    passengerClass: AvailablePassengerClassType,
}

function PassengerClassSummary({passengerIdsGroups, passengerClass}: PassengerClassSummaryProps) {
    const onlyPayablePassengerClassesGroups = passengerIdsGroups.filter((passengerIdsGroup) => (
        passengerClass.prices[passengerIdsGroup.length]
    ))

    const {getPassengerClassGroupPrice} = useGetPassengerClassPrices()
    const {getPassengersList} = useGetPassengersName()

    return (
        <>
            {onlyPayablePassengerClassesGroups.map((passengerIdsGroup) => (
                <PriceFractionDisplay
                    key={passengerIdsGroup.join("-")}
                    fractionTitle={`${passengerClass.title} (${getPassengersList(passengerIdsGroup)})`}
                    price={getPassengerClassGroupPrice(passengerClass, passengerIdsGroup).displayablePrice}
                />
            ))}
        </>
    )
}

export default PassengerClassSummary